import { useQuery } from "@tanstack/react-query";
import { useOrderContext } from "app/providers/OrderProvider";
import { api } from "shared/api";

export const useOrderBumbalData = () => {
  const { order, type } = useOrderContext();

  const {
    isLoading: isOrderBumbalDataLoading,
    error: orderBumbalDataError,
    data: orderBumbalData,
    isSuccess: isOrderBumbalDataFetched,
  } = useQuery({
    queryKey: ["getOrderBumbalData"],
    queryFn: async () => {
      const res = await api().gersGetOrderBumbalData(order!.id, type);
      return res.data;
    },
    refetchOnWindowFocus: false,
    enabled: !!order,
  });

  return {
    isOrderBumbalDataFetched,
    isOrderBumbalDataLoading,
    orderBumbalData,
    orderBumbalDataError,
  };
};
